import React, { Component } from 'react';
import { EmojiMessage } from 'react/elements/EmojiMessage';
import { Provider } from 'react-redux';
import store from 'react/redux/store/store';

import { Stream } from 'models/Stream.jsx';
import { Dashboard } from '../../../../../components/Dashboard';
import EditingMessageComponent from './EditingMessageComponent';
import { LadderLinker } from '../../../../../components/LadderLinker';
import SpinningGear from "../../../../elements/loaders/SpinningGear";

class PlayerMessageTextComponent extends Component {

	constructor(props) {
		super(props);
		this.state = {
			displayingWarning: true,
		};

		this.editMessageKeydown = this.editMessageKeydown.bind(this);
		this.dismissWarningClick = this.dismissWarningClick.bind(this);
	}

	dismissWarningClick() {
		this.setState({ displayingWarning: false });
	}

	editMessageKeydown(e) {
		const { message, chatMessages, endChatMessageEditMode, submitMessageEdit } = this.props;
		if(e.which === Dashboard.keyCodes.ESCAPE) {
			endChatMessageEditMode();
			chatMessages.focusInput();
		}
		if(e.which === Dashboard.keyCodes.ENTER) {
			e.preventDefault();
			const text = e.target.value;
			message.message = text;
			message.editedMessage = LadderLinker.autolinkMessage({ message: text }, true);
			submitMessageEdit(message, text);

			chatMessages.focusInput();
		}
	}

	render() {
		const { message, messageReact, displayMannersWarning, displayScamWarning, isEditing, submittingUpdate } = this.props;
		const { displayingWarning } = this.state;

		return (
			<span className='message_things'>
                {isEditing &&
                <Provider store={store}>
	                <EditingMessageComponent
		                onKeyDown={this.editMessageKeydown}
		                text={message.message}
	                />
                </Provider>
                }
				{!isEditing &&
				<NormalMessageComponent
					message={message}
					messageReact={messageReact}
				/>
				}
				{displayingWarning && displayMannersWarning &&
				<span
					className='warning'
				>
					You accepted a match with a player that is (hopefully) temporarily flagged for anti-social behavior so they may
						be rude, threatening, harassing, or hostile -
						you 100% have the option to avoid players reported for this behavior if you so choose
					</span>
				}
				{message.isMuted() && message.hasMuteTime() &&
				<span className='warning'> - You are muted until {message.is_muted.calendar().toLowerCase()}</span>
				}
				{!!message.edited &&
				<span className='edited' />
				}
				{submittingUpdate &&
				<SpinningGear />
				}
            </span>
		);
	}
}

class NormalMessageComponent extends Component {

	constructor(props) {
		super(props);
		this.messageHover = this.messageHover.bind(this);
		this.messageClick = this.messageClick.bind(this);
	}

	messageClick(e) {
		const target = $(e.target);
		if(target.hasClass('streamlink')) {
			e.preventDefault();
			e.stopPropagation();
			Stream.streamClick(target, { x: e.nativeEvent.pageX, y: e.nativeEvent.pageY });
		}
	}

	messageHover(e) {
		const target = $(e.target);
		if(target.hasClass('youtubelink')) {
			this.youtubeLinkHover(target);
		}
	}

	youtubeLinkHover(button) {
		if(!button.data('id')) {
			return;
		}
		if(button.hasClass('coolhover')) {
			return;
		}
		button.addClass('coolhover');
		var error = function() {
			button.removeClass('coolhover');
		};
		$.ajax({
			url: 'https://www.googleapis.com/youtube/v3/videos?id=' + button.data('id') + '&key=' + youtubeBrowserApiKey + '&fields=items(snippet(title))&part=snippet',
			type: 'GET',
			crossDomain: true,
			dataType: 'jsonp',
			success: function(response) {
				if(response.items) {
					var first = response.items.pop();
					var title = first.snippet.title;
					if(title.length > 80) {
						title = title.substring(0, 80) + '...';
					}
					if(title.length !== 0) {
						button.text(title).attr('title', first.snippet.title);
					}
				}
				else {
					error();
				}
			},
			error: function() {
				error();
			}
		});
	}

	render() {
		const { message, messageReact } = this.props;
		return (
			<span
				onClick={this.messageClick}
				onMouseOver={this.messageHover}
				className='message'

			>
				<EmojiMessage text={message.message}>{messageReact}</EmojiMessage>
			</span>
		);
	}
}

export { PlayerMessageTextComponent };